import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addProduct } from "../redux/products/actions";

const Form = () => {
  const [product, setProduct] = useState({});
  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    setProduct({ ...product, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(addProduct(product));
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-4 text-[#534F4F]"
      id="lws-addProductForm"
    >
      <div className="space-y-2">
        <label htmlFor="lws-inputName">Product Name</label>
        <input
          name="name"
          className="addProductInput"
          id="lws-inputName"
          type="text"
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="space-y-2">
        <label htmlFor="lws-inputCategory">Category</label>
        <input
          name="category"
          className="addProductInput"
          id="lws-inputCategory"
          type="text"
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="space-y-2">
        <label htmlFor="lws-inputImage">Image Url</label>
        <input
          name="imgUrl"
          className="addProductInput"
          id="lws-inputImage"
          type="text"
          onChange={handleInputChange}
          required
        />
      </div>
      <div className="grid grid-cols-2 gap-8 pb-4">
        <div className="space-y-2">
          <label htmlFor="ws-inputPrice">Price</label>
          <input
            name="price"
            className="addProductInput"
            type="number"
            id="lws-inputPrice"
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="space-y-2">
          <label htmlFor="lws-inputQuantity">Quantity</label>
          <input
            name="quantity"
            className="addProductInput"
            type="number"
            id="lws-inputQuantity"
            onChange={handleInputChange}
            required
          />
        </div>
      </div>
      <button type="submit" id="lws-inputSubmit" className="submit">
        Add Product
      </button>
    </form>
  );
};

export default Form;
